<div class="page-wrapper">
  @if (menuData().status === 'loading') {
    <div class="loader-overlay">
      <div class="spinner-wrapper">
        <app-loader-overlay></app-loader-overlay>
      </div>
    </div>
  }

  <div class="homepage-container" [class.blurred]="menuData().status === 'loading'">
    <section class="main-content">
      <div class="welcome-container">
        <img src="../../../../favicon.ico" alt="NTT Data" class="ntt-icon" />
        <span>
          Hi, <b>{{ selectedUser()?.name }}</b>
        </span>
        <span>How can we help you ignite your tomorrow, today?</span>
      </div>

      <div class="search-container">
        <mat-form-field class="search-menu" appearance="outline">
          <mat-label>Search by...</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="modelSearchTerm"
            placeholder="Search by..."
            (ngModelChange)="onSearchTermChange($event)"
          />

          @if (modelSearchTerm) {
            <button matSuffix mat-icon-button aria-label="Clear" class="btn-clear" (click)="clearSearchTerm()">
              <mat-icon>close</mat-icon>
            </button>
          }

          <button matSuffix mat-icon-button aria-label="Search" class="btn-search">
            <i class="fa-solid fa-magnifying-glass"></i>
          </button>
        </mat-form-field>
      </div>

      <div class="cards-menu-container">
        @if (menuData()) {
          @if (isHome()) {
            <div class="tab-menu-group">
              <hr class="divisor-dashed" />
              <app-tab-group [tabButtonGroup]="tabButtonGroup()" (selectedTab)="filterMenuItemsByCategory($event)" />
              <hr class="divisor-dashed" />
            </div>
          } @else {
            <div class="breadcrumb-container">
              <app-breadcrumb-home
                [breadcrumbItems]="breadcrumbItems()"
                (breadcrumbClick)="onBreadcrumbClick($event)"
              />
            </div>
          }

          @if (selectedCategory() === 'favorites') {
            <app-favorites-cards [displayedMenuItems]="displayedMenuItems()" (onToggleFavorite)="onToggleFavorite($event)" />
          } @else {
            <div class="card-container">
              @for (cardMenu of displayedMenuItems(); track cardMenu.title) {
                <app-card-menu
                  [cardItem]="cardMenu"
                  (parentClicked)="onParentClicked($event)"
                  (toggleFavorite)="onToggleFavorite($event)"
                />
              }
            </div>
          }
        } @else {
          <div class="not-found">
            <img src="../../../../assets/images/icons/not_tasks.png" alt="No data found." class="img-notFound" />
            <p>
              No results found for "<b>{{ modelSearchTerm }}</b
              >".
            </p>
          </div>
        }
      </div>
    </section>
  </div>

  <app-feedback-fab (feedbackClick)="openFeedbackModal()"></app-feedback-fab>
</div>
